<template>
  <div>
    <header-yjj></header-yjj>
    <header-img-yjj></header-img-yjj>
    <div class="container">
      <p class="nav">当前位置：首页——教育活动</p>

      <div class="content">
        <div class="leftNav">
          <h2>栏目导航</h2>
          <div>
            <ul>
              <router-link to="" ><li :class="{active:activeFlag == 'tongzhi'}" @click="navCur('tongzhi')">宣教之窗</li></router-link>
              <router-link to="" ><li :class="{active:activeFlag == 'dongtai'}" @click="navCur('dongtai')">流动巡展</li></router-link>
              <router-link to="" ><li :class="{active:activeFlag == 'duanshipin'}" @click="navCur('duanshipin')">主题活动</li></router-link>
              <router-link to="" ><li :class="{active:activeFlag == 'minzu'}" @click="navCur('minzu')">民族团结</li></router-link>
            </ul>
          </div>
        </div>
        <div class="rightCol">
          <div class="rightCol-c">
            <h2>
              <span>教育活动</span>
            </h2>
            <div class="newsList">
              <ul>
                <li v-for="item in newsList" :key="item.index">
                  <router-link :to="{name:'ArticleContentYjj',params:{id:item.id}}">
                    {{item.title}}
                    <span>{{item.createTime | dataFormat('yyyy-mm-dd')}}</span>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div style="clear: both"></div>

      </div>

      <!--    民族团结开始    -->
      <div>
        <img src="http://cdn.hxjmzz.com/W020210910603641011881.jpg" style="width:100%;">
      </div>

      <div style="height:400px;">
        <h2 style="text-align: center;color: #951D1D;margin-top: 40px;">
          <span style="border-bottom: #951D1D 5px solid;padding:0 0 3px;">
            <span  style="border-bottom: #951D1D 1px solid;padding:0 0 10px;">红色丰碑</span>
          </span>

        </h2>
        <div>

        </div>
      </div>


      <div style="display: flex">
        <div style="flex:1">
          <h2>
            <span></span>
            <span></span>
            理论教育</h2>
        </div>
        <div style="flex:1">

        </div>
      </div>
      <!--    民族团结结束    -->


    </div>

    <!--  底部模板  -->
    <footer-yjj></footer-yjj>
  </div>
</template>

<script>
import HeaderYjj from "@/components/yjj/HeaderYjj";
import FooterYjj from "@/components/yjj/FooterYjj";
import HeaderImgYjj from "@/components/yjj/HeaderImgYjj";
import {request} from "@/request/request";

export default {
  name: "EduListYjj",
  components:{
    HeaderYjj,
    FooterYjj,
    HeaderImgYjj
  },
  data(){
    return{

      activeFlag:'tongzhi',
      restfulUrl:'articles',
      newsList:[]
    }
  },
  methods:{
    navCur(data){
      this.activeFlag = data;
      if(data == 'tongzhi'){
        this.getListByColumn(8)
      }
      if(data == 'dongtai'){
        this.getListByColumn(9)
      }
      if(data == 'video'){
        this.getListByColumn(10)
      }
      if(data == 'minzu'){
        this.getListByColumn(11)
      }
    },
    getListByColumn(column){
      request({
        method:'POST',
        url:this.restfulUrl+'/getbycolumn',
        data:{columnId:column}
      }).then(res =>{
        this.newsList = res.data;
      },err=>{
        console.log(err)
      })
    }
  },
  mounted() {
    this.getListByColumn(8)
  },
  filters:{
    dataFormat(input,pattern=''){
      var dt = new Date(input);
      var y = dt.getFullYear();
      var m = (dt.getMonth() + 1).toString().padStart(2, '0');
      var d = dt.getDate().toString().padStart(2, '0');

      if (pattern.toLowerCase() === 'yyyy-mm-dd') {
        return `${y}-${m}-${d}`;
      } else {
        // 获取时分秒
        var hh = dt.getHours().toString().padStart(2, '0');
        var mm = dt.getMinutes().toString().padStart(2, '0');
        var ss = dt.getSeconds().toString().padStart(2, '0');

        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;

      }

    }
  },
  metaInfo() {
    return {
      title: this.$route.meta.title || 'My Vue App'
    };
  }
}
</script>

<style scoped>

.container{
  width:70%;
  margin: 0 auto;
  padding:10px 0;
}
.active{
  color:#9E1A28;
  font-weight: bold;
}
.nav{
  text-align: left;
}
.content{
  display: flex;
  margin-top: 20px;
}
.content .leftNav{
  flex:1
}
.leftNav h2{
  color: white;
  height: 60px;
  line-height: 60px;
  background: #9E1A28;
}
.leftNav div{
  margin-top: 10px;
  border: 1px solid silver;
}
.leftNav div{
  padding-bottom: 20px;
}
.leftNav div ul{
  padding:0 20px;
}
.leftNav div ul li {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px silver dashed;
}
.leftNav div ul a{
  color: black;
  text-decoration: none;
}
.rightCol{
  flex: 4;

}
.rightCol-c{
  padding:10px 0 0 60px;
}
.rightCol-c h2{
  padding-bottom: 10px;
  border-bottom: 1px solid silver;
  text-align: left;
}
.rightCol-c h2 span{
  color: #9E1A28;
  padding-bottom: 6px;
  border-bottom: 5px solid #9E1A28;
}
.newsList{
  text-align: left;
  padding:20px;
  min-height: 250px;
}
.newsList li{
  line-height: 50px;
  border-bottom: 1px silver dashed;
}
.newsList a{
  color:black;
  text-decoration: none;
  font-size: 18px;
}
.newsList a span{
  float: right;
}
</style>
